<div class="container page-content">
  <div class="row">
    <div class="col-3">
      <div class="card">
        <div class="card-header">{{ "settings" | i18n }}</div>
        <div class="list-group list-group-flush">
          <a
            routerLink="account"
            class="list-group-item"
            routerLinkActive="active"
            *ngIf="organization?.isOwner"
          >
            {{ "organizationInfo" | i18n }}
          </a>
          <a
            routerLink="policies"
            class="list-group-item"
            routerLinkActive="active"
            *ngIf="organization?.canManagePolicies"
          >
            {{ "policies" | i18n }}
          </a>
          <a
            routerLink="two-factor"
            class="list-group-item"
            routerLinkActive="active"
            *ngIf="organization?.use2fa && organization?.isOwner"
          >
            {{ "twoStepLogin" | i18n }}
          </a>
          <a
            routerLink="tools/import"
            class="list-group-item"
            routerLinkActive="active"
            *ngIf="organization?.canAccessImportExport"
          >
            {{ "importData" | i18n }}
          </a>
          <a
            routerLink="tools/export"
            class="list-group-item"
            routerLinkActive="active"
            *ngIf="organization?.canAccessImportExport"
          >
            {{ "exportVault" | i18n }}
          </a>
          <a
            routerLink="sso"
            class="list-group-item"
            routerLinkActive="active"
            *ngIf="organization?.canManageSso"
          >
            {{ "singleSignOn" | i18n }}
          </a>
          <a
            routerLink="scim"
            class="list-group-item"
            routerLinkActive="active"
            *ngIf="organization?.canManageScim"
          >
            {{ "scim" | i18n }}
          </a>
        </div>
      </div>
    </div>
    <div class="col-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
